<template>
    <div class="addoffercode" style="min-height:85vh">
        <div>
            <div style="margin: 16px 0;display:flex">
                <a-breadcrumb style="margin-top:auto;margin-bottom:auto">
                    <a-breadcrumb-item style="font-size:30px;">Add Offer Code</a-breadcrumb-item>
                    <!-- <a-breadcrumb-item>Bill</a-breadcrumb-item> -->
                </a-breadcrumb>
            </div>
            <div style="text-align:left">Create a new offer code and add them to this site.</div>
            <div style="display:flex;margin-top:20px">
                <div style="width:200px;text-align:left;margin-top:auto;margin-bottom:auto">Offer Code Name (required)</div>
                <a-input style="width:300px;margin-top:auto;margin-bottom:auto" v-model="name" placeholder="" />
            </div>
            <div style="display:flex;margin-top:20px">
                <div style="width:200px;text-align:left;margin-top:auto;margin-bottom:auto">Offer Code Value (required)</div>
                <a-input-number style="width:300px;margin-top:auto;margin-bottom:auto" v-model="value" placeholder="" />
            </div>
            <div style="display:flex;margin-top:20px">
                <div style="width:200px;text-align:left;margin-top:5px;">Description</div>
                <a-textarea style="width:300px;margin-top:auto;margin-bottom:auto" v-model="description" placeholder="" :auto-size="{ minRows: 6, maxRows: 8 }" />
            </div>
            
            <div style="display:flex;margin-top:20px">
                <a-button style="margin-top:auto;margin-bottom:auto;" type="primary" v-on:click="addNewOfferCode">
                    Add New Offer Code
                </a-button>
            </div>
        </div>
        
    </div>
</template>
<script>
import { api } from '../helpers/Helpers';

export default {
    data() {
    return {
        name: '',
        value: '',
        description: '',
    };
  },
    methods: {
        addNewOfferCode: async function(){
            if (this.name === "" || this.value === "" || this.value === null){
                this.$message.error('Please input correct information.');
                return;
            }

            const offerCodeData = {
                name: this.name,
                value: this.value,
                description: this.description,
                creator: this.$store.state.loginAdmin.id,
                createdDate: new Date(),
                updatedDate: new Date()
            };

            const res = await api.createOfferCode(offerCodeData);

            if (res != undefined && res != "" && res.error == undefined){
                this.$message.success('Add Offer Code Success!');
                this.$emit('close');
                this.$router.push({ path: 'offercodes' })
            }
            else{
                this.$message.error(res.error);
            }
        }
    },
}
</script>